import React, { Component, Fragment } from "react";
import { Accordion, Card } from "react-bootstrap";
import moment from "moment";

import TaContext from './TaContext';
import { CurrencyUtils } from "../../utils";
import { DATETHAI_FORMAT, DATE_FORMAT } from "../../const";

import WidgetSummary from "../../components/WidgetSummary";
import BenefitBlock from "../../components/BenefitBlock";
import CheckBoxReceived from "../../components/CheckBoxReceived";
import CheckBoxInsuranceConfirm from "../../components/CheckBoxInsuranceConfirm";

import UserIcon from "../../images/user_icon.svg";
import Edit from "../../images/edit.svg";
import ChevonDown from "../../images/chevron-down.svg";


const imgScale = {
  width: "24px",
  height: "24px",
};
const Icon = (props) => (
  <img className={props.className} src={props.src} {...imgScale} />
);

class Step4 extends Component {
  render() {
    const { diffDate, step1, step2, step4 } = this.context;
    const {
      start_date,
      end_date,
      counter,
      provinceFrom,
      provinceTo,
      provinceOther,
    } = step1;

    const { selectedPlan, planList } = step2;
    const planDetail =
      planList.filter((plan) => plan.id === selectedPlan)[0] || {};
    const { insured, total } = planDetail;
    const {
      recieveEmail,
      recievePost,
      onChangeModel,
      confirmInsurance,
    } = step4;
    const { insures } = this.context.step3 || {};
    const totalAmount = counter ? total * counter : total;

    const from = provinceFrom ? provinceFrom.label + "-" : "";
    const otherConcat = (provinceOther || []).map((po) => po.label).join("-");
    const to = provinceTo ? "-" + provinceTo.label : "";
    const { onEditUser } = this.context.step4 || {};
    
    
    return (
      <>
      <div className="form-wrapper info">
        <div className="form-group">
          <label>ทุนประกัน</label>
          <label className="value">
            {CurrencyUtils.currency(insured)} บาท
          </label>
        </div>
        <div className="form-group">
          <label>ระยะเวลาเอาประกัน</label>
          <label className="value">
            {moment(start_date).format(DATETHAI_FORMAT)} -{" "}
            {moment(end_date).format(DATETHAI_FORMAT)}
          </label>
        </div>
        <div className="form-group">
          <label>วันเดินทางและจำนวนคน</label>
          <label className="value">
            {diffDate} วัน {counter} คน
          </label>
        </div>
        <div className="form-group">
          <label>จังหวัดที่เดินทาง</label>
          <label className="value">{from + otherConcat + to}</label>
        </div>
        <div className="summary-reactagle">
          <div className="form-group">
            <label>รายการเบี้ยประกันรวม</label>
            <label className="totalPrice">
              {CurrencyUtils.currency(totalAmount)} บาท
            </label>
            <label className="help">
              (เบี้ยประกันภัยรวมภาษีและอากรแสตมป์แล้ว)
            </label>

            <WidgetSummary planDetail={planDetail} />
          </div>
        </div>
        <div className="form-group">
          <Accordion defaultActiveKey={"0"} className="accordion-wrapper">
            {insures &&
              insures.map((insure, index) => {
                const {
                  sNationality,
                  sIDNo = "",
                  sPassportNo = "",
                  sInitNameTH = "",
                  sFirstNameTH = "",
                  sLastNameTH = "",
                  sInitNameEN = "",
                  sFirstNameEN = "",
                  sLastNameEN = "",
                  sBirthDate = "",
                  sMobile = "",
                  sEmail = "",
                  sNo = "",
                  sMoo = "",
                  sSoi = "",
                  sRoad = "",
                  sProvince = "",
                  sDistrict = "",
                  sCity = "",
                  sZipcode = "",
                } = insure;

                const diffDate = sBirthDate
                  ? moment.utc().diff(moment(sBirthDate), "years")
                  : "-";

                const no = sNo
                  ? `เลขที่ ${sNo} `
                  : !sNo && insure.isSameIdentity == 1
                  ? `เลขที่ ${insures[0].sNo} `
                  : ``;
                const moo = sMoo
                  ? `หมู่ ${sMoo} `
                  : !sMoo && insure.isSameIdentity === 1
                  ? `หมู่ ${insures[0].sMoo} `
                  : ``;
                const soi = sSoi
                  ? `ซอย ${sSoi} `
                  : !sSoi && insure.isSameIdentity === 1
                  ? `ซอย ${insures[0].sSoi} `
                  : ``;
                const road = sRoad
                  ? `ถนน${sRoad} `
                  : !sRoad && insure.isSameIdentity === 1
                  ? `ถนน${insures[0].sRoad} `
                  : ``;
                const subDistrict = sDistrict
                  ? `แขวง${sDistrict.label} `
                  : !sDistrict && insure.isSameIdentity === 1
                  ? `แขวง${insures[0].sDistrict.label} `
                  : ``;
                const district = sCity
                  ? `เขต${sCity.label} `
                  : !sCity && insure.isSameIdentity === 1
                  ? `เขต${insures[0].sCity.label} `
                  : ``;
                const province = sProvince
                  ? `${sProvince.label} `
                  : !sProvince && insure.isSameIdentity === 1
                  ? `${insures[0].sProvince.label} `
                  : ``;
                const zipcode = sZipcode
                  ? `${sZipcode} `
                  : !sZipcode && insure.isSameIdentity === 1
                  ? `${insures[0].sZipcode} `
                  : ``;
                const address = `${no}${moo}${soi}${road}${subDistrict}${district}${province}${zipcode}`;

                return (
                  <Card className="accordion-item" key={index}>
                    <div className="d-flex align-item-center ml-3">
                      <Icon src={UserIcon} />
                      <p className="header-accordion-text">
                        ผู้เอาประกันภัยคนที่ {index + 1}
                      </p>
                      <div
                        className="ml-auto mr-3"
                        onClick={() =>
                          onEditUser({ name: "editKey", value: index })
                        }
                      >
                        <Icon src={Edit} />
                      </div>
                      <Accordion.Toggle
                        className="pl-0"
                        as={Card.Header}
                        eventKey={`${index}`}
                      >
                        <Icon src={ChevonDown} />
                      </Accordion.Toggle>
                    </div>
                    <Accordion.Collapse eventKey={`${index}`}>
                      <Card.Body className="accordion-body">
                        {sNationality && sNationality.value === "THA" ? (
                          <div className="form-group">
                            <label>บัตรประชาชน</label>
                            <p>{sIDNo}</p>
                          </div>
                        ) : (
                          <div className="form-group">
                            <label>หนังสือเดินทาง</label>
                            <p>{sPassportNo}</p>
                          </div>
                        )}
                        <div className="form-group">
                          <label>ชื่อ-สกุล (ภาษาไทย)</label>
                          <p>
                            {sInitNameTH.label}{sFirstNameTH} {sLastNameTH}
                          </p>
                        </div>
                        <div className="form-group">
                          <label>ชื่อ-สกุล (อังกฤษ)</label>
                          <p>
                            {sInitNameEN.label}{sFirstNameEN} {sLastNameEN}
                          </p>
                        </div>
                        <div className="form-group">
                          <label>วันเกิด</label>
                          <p>{this.context.step1.langague === 1 ?
                          moment(sBirthDate)
                          .locale("th")
                          .add(543,'year')
                          .format(DATE_FORMAT) :
                          moment(sBirthDate)
                          .format(DATE_FORMAT)
                          }</p>
                        </div>
                        <div className="form-group">
                          <label>อายุ</label>
                          <p>{diffDate} ปี</p>
                        </div>
                        <div className="form-group">
                          <label>เบอร์โทรศัพท์</label>
                          <p>{sMobile}</p>
                        </div>
                        <div className="form-group">
                          <label>อีเมล</label>
                          <p>{sEmail}</p>
                        </div>
                        <hr />
                        <div className="form-group">
                          <label>ที่อยู่ผู้เอาประกันและจัดส่งกรมธรรม์</label>
                          <p>{address}</p>
                        </div>
                        {/* Benefit Section */}
                        {insure.benefits.map((benefit, index) => {
                          return benefit ? (
                            <BenefitBlock
                              key={index}
                              index={index}
                              benefit={benefit}
                            />
                          ) : (
                            ""
                          );
                        })}
                        <hr />
                        <div className="form-group">
                          <label>อีเมลสำหรับข้อมูลกรรมธรรม์</label>
                          <p>{sEmail}</p>
                        </div>
                        <div className="form-group">
                          <label>เบอร์ติดต่อ</label>
                          <p>{sMobile}</p>
                        </div>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                );
              })}
          </Accordion>
        </div>

        <CheckBoxReceived
          recieveEmail={recieveEmail}
          recievePost={recievePost}
          onChangeModel={onChangeModel}
        />
      </div>
      <div className="form-wrapper">
        <CheckBoxInsuranceConfirm
          checked={confirmInsurance}
          onCheckChange={(checked) =>
            onChangeModel({ name: "confirmInsurance", value: checked })
          }
        />
      </div>
    </>  
    )
  }
}


Step4.contextType = TaContext;
export default Step4;
